import {
  ADD_CONTRACT,
  GET_CONTTRACT,
  SALE_REGISTER,
  EDIT_FABRIC,
  EDIT_CONVERSION,
  DELETE_CONTRACT,
} from "../Action/contract";
import { EDIT_INVOCIE, DELETE_INVOCIE } from "../Types";

const initialState = {
  contracts: [],
  invoices: [],
};

function contractReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_CONTRACT: {
      return { contracts: [action.payload, ...state.contracts] };
    }
    case GET_CONTTRACT: {
      const totalContract = action.payload;
      return { ...state, contracts: totalContract };
    }

    case EDIT_FABRIC: {
      console.log(action.payload);
      let UpdatedContract = state.contracts.map((item) =>
        // broker_id is alternative
        item.broker_id === action.payload.id ? action.payload : item
      );
      console.log("UpdatedContract", UpdatedContract);
      return {
        ...state,
        contracts: UpdatedContract,
      };
    }
    case EDIT_CONVERSION: {
      let UpdatedConContract = state.contracts.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

      return {
        ...state,
        contracts: UpdatedConContract,
      };
    }

    case DELETE_CONTRACT: {
      const after_delete_contract = state.contracts.filter(
        (contract) => contract.id !== action.payload.id
      );
      console.log(after_delete_contract);
      return { ...state, contracts: after_delete_contract };
    }
    case SALE_REGISTER: {
      return { ...state, invoices: action.payload };
    }
    case EDIT_INVOCIE: {
      let updateInvoiceList = state.invoices.map((item) =>
        item.invoice_id === action.payload.invoice_id ? action.payload : item
      );
      return {
        ...state,
        invoices: updateInvoiceList,
      };
    }
    case DELETE_INVOCIE: {
      const after_delete_invoice = state.invoices.filter(
        (invoice) => invoice.invoice_id !== action.payload.invoice_id
      );
      return { ...state, invoices: after_delete_invoice };
    }

    default:
      return state;
  }
}

export default contractReducer;
